import React, { useState, useEffect } from "react";
import motivationalQuotes from "../../assets/motivationalQuotes.json";
import { useLocation } from "react-router-dom";

const MotivationPopup = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [quote, setQuote] = useState("");

  // Routes where popup should NOT appear
  const disabledRoutes = [
    "/login",
    "/register",
    "/forgot-password",
    "/two-step-verification",
    "/public/l/forms", // Public lead forms
    "/careers"
  ];

  const isDisabledRoute = disabledRoutes.some(
    (route) =>
      location.pathname === route || location.pathname.startsWith(route)
  );

  useEffect(() => {
    if (isDisabledRoute) {
      return;
    }
    const triggerQuote = () => {
      const randomQuote =
        motivationalQuotes[
        Math.floor(Math.random() * motivationalQuotes.length)
        ];
      setQuote(randomQuote);
      setShow(true);

      // Play notification sound
      const audio = new Audio("/sounds/notification.mp3");
      audio.volume = 1.0; // Set volume to maximum
      audio.play().catch((e) => console.warn("Audio play failed:", e));
    };

    triggerQuote(); // Show once initially

    const interval = setInterval(triggerQuote, 3600000); // Every 1 minute

    return () => clearInterval(interval);
  }, []);

  if (!show || isDisabledRoute) return null;

  return (
    <div style={styles.container}>
      <div style={styles.popup}>
        <span style={styles.closeBtn} onClick={() => setShow(false)}>
          ✖
        </span>

        <img
          src="../../assets/img/motivation_avatar.svg"
          alt="Motivator"
          onClick={() => {
            speechSynthesis.cancel();
            const utter = new SpeechSynthesisUtterance(quote);
            speechSynthesis.speak(utter);
          }}
          style={styles.image}
        />

        <div style={styles.bubble}>{quote}</div>
      </div>
    </div>
  );
};

const styles: {
  container: React.CSSProperties;
  popup: React.CSSProperties;
  closeBtn: React.CSSProperties;
  bubble: React.CSSProperties;
  image: React.CSSProperties;
} = {
  container: {
    position: "fixed",
    bottom: "20px",
    left: "20px",
    zIndex: 9999,
  },
  popup: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    animation: "slideUp 0.6s ease-out",
  },
  image: {
    width: "80px",
    height: "80px",
    cursor: "pointer",
  },
  closeBtn: {
    position: "absolute",
    top: "-10px",
    right: "-10px",
    width: "24px",
    height: "24px",
    background: "#fff",
    borderRadius: "50%",
    border: "1px solid #ccc",
    cursor: "pointer",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  bubble: {
    marginLeft: "10px",
    background: "#fff9c4",
    borderRadius: "10px",
    padding: "10px 15px",
    maxWidth: "250px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    fontSize: "14px",
    color: "#333",
  },
};

export default MotivationPopup;
